import { CommercialServicesApi, DealsheetsApi, DocRefsApi, DocsApi, InvoiceGraderApi, IssuesApi, LocationsApi, OrderItemsApi, OrderPortaloosApi, EquipmentServicesApi, OtherServicesApi, RfpSitesApi, RfpsApi, CrmV1RfpSitesGetRecommendedEnum, RollOffServicesApi, ServiceLocationsApi, SitesApi, } from '@wayste/crm-client';
class CRMService {
    axiosInstance;
    commercialServicesApi;
    dealsheetsApi;
    invoiceGraderApi;
    docRefsApi;
    docsApi;
    issuesApi;
    locationsApi;
    orderItemsApi;
    orderPortaloosApi;
    equipmentServicesApi;
    otherServicesApi;
    rollOffServicesApi;
    rfpsApi;
    rfpSitesApi;
    serviceLocationsApi;
    sitesApi;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.commercialServicesApi = new CommercialServicesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.dealsheetsApi = new DealsheetsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.invoiceGraderApi = new InvoiceGraderApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.docRefsApi = new DocRefsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.docsApi = new DocsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.issuesApi = new IssuesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.locationsApi = new LocationsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderItemsApi = new OrderItemsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.orderPortaloosApi = new OrderPortaloosApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.equipmentServicesApi = new EquipmentServicesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.otherServicesApi = new OtherServicesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.rollOffServicesApi = new RollOffServicesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.rfpsApi = new RfpsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.rfpSitesApi = new RfpSitesApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.serviceLocationsApi = new ServiceLocationsApi(undefined, undefined, this.axiosInstance.mainInstance);
        this.sitesApi = new SitesApi(undefined, undefined, this.axiosInstance.mainInstance);
    }
    adminPortal = {
        commercialServices: {
            list: async (options) => {
                const response = await this.commercialServicesApi.crmV1DealsheetCommercialServicesGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.commercialServicesApi.crmV1DealsheetCommercialServicesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.commercialServicesApi.crmV1DealsheetCommercialServicesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.commercialServicesApi.crmV1DealsheetCommercialServicesIdDelete(params);
            },
            duplicate: async (params) => {
                const response = await this.commercialServicesApi.crmV1DealsheetCommercialServicesIdDuplicatePost(params);
                return response.data;
            },
        },
        dealsheets: {
            /** One page of the org's deal sheets, newest first, with the total number that match. */
            list: async (params) => {
                const response = await this.axiosInstance.mainInstance.get('/crm/v1/dealsheets', { params });
                return response.data;
            },
            /**
             * Runs a search UI query against the crm-dealsheet index. The response keeps the
             * Elasticsearch hits shape, so the search UI pages it by the true total.
             */
            search: async (params) => {
                const response = await this.axiosInstance.mainInstance.post('/crm/v1/dealsheets/search', params);
                return response.data;
            },
            /** Drops and recreates the crm-dealsheet index, then reindexes every deal sheet. */
            reindex: async () => {
                const response = await this.axiosInstance.mainInstance.post('/crm/v1/dealsheets/reindex');
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.dealsheetsApi.crmV1DealsheetsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.dealsheetsApi.crmV1DealsheetsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.dealsheetsApi.crmV1DealsheetsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.dealsheetsApi.crmV1DealsheetsIdDelete(params);
            },
            /**
             * The customer-facing proposal, rendered from the deal sheet's recommended sites.
             * Served by the PDF renderer rather than the CRM API, so it does not go through the
             * generated client.
             */
            proposalPdf: async (dealsheetID, params) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/admin-portal/proposal/${dealsheetID}`, {
                    responseType: 'blob',
                    params,
                });
                return res.data;
            },
        },
        docRefs: {
            list: async (options) => {
                const response = await this.docRefsApi.crmV1DocRefsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.docRefsApi.crmV1DocRefsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.docRefsApi.crmV1DocRefsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.docRefsApi.crmV1DocRefsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.docRefsApi.crmV1DocRefsIdDelete(params);
            },
        },
        invoiceGrader: {
            list: async (options) => {
                const response = await this.invoiceGraderApi.crmV1InvoiceGraderSubmissionsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.invoiceGraderApi.crmV1InvoiceGraderSubmissionsIdGet(params);
                return response.data;
            },
        },
        documents: {
            list: async (options) => {
                const response = await this.docsApi.crmV1DocsGet(options);
                return response.data;
            },
            listByRefId: async (params) => {
                const response = await this.docsApi.crmV1DocsByRefIdRefIDGet(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.docsApi.crmV1DocsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.docsApi.crmV1DocsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.docsApi.crmV1DocsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.docsApi.crmV1DocsIdDelete(params);
            },
        },
        locations: {
            list: async (options) => {
                const response = await this.locationsApi.crmV1LocationsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.locationsApi.crmV1LocationsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.locationsApi.crmV1LocationsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.locationsApi.crmV1LocationsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.locationsApi.crmV1LocationsIdDelete(params);
            },
        },
        orderItems: {
            list: async (options) => {
                const response = await this.orderItemsApi.crmV1OrderItemsGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.orderItemsApi.crmV1OrderItemsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderItemsApi.crmV1OrderItemsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.orderItemsApi.crmV1OrderItemsIdDelete(params);
            },
            createOrUpdateOneTimeCharge: async (params) => {
                const response = await this.orderItemsApi.crmV1OrderItemsCreateOrUpdateOneTimeChargePost(params);
                return response.data;
            },
        },
        equipmentServices: {
            list: async (options) => {
                const response = await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesIdDelete(params);
            },
            duplicate: async (params) => {
                const response = await this.equipmentServicesApi.crmV1DealsheetEquipmentServicesIdDuplicatePost(params);
                return response.data;
            },
        },
        otherServices: {
            list: async (options) => {
                const response = await this.otherServicesApi.crmV1DealsheetOtherServicesGet(options);
                return response.data;
            },
            create: async (params) => {
                const response = await this.otherServicesApi.crmV1DealsheetOtherServicesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.otherServicesApi.crmV1DealsheetOtherServicesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.otherServicesApi.crmV1DealsheetOtherServicesIdDelete(params);
            },
            duplicate: async (params) => {
                const response = await this.otherServicesApi.crmV1DealsheetOtherServicesIdDuplicatePost(params);
                return response.data;
            },
        },
        rollOffServices: {
            list: async (options) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesGet(options);
                return response.data;
            },
            /**
             * Same list, plus the monthly figures derived from the site's observed haul volume.
             * Costs a site fetch server-side, so it is opt-in rather than the default.
             */
            listWithRates: async (options) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesGet({ ...options, withRates: 'true' });
                return response.data;
            },
            create: async (params) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.rollOffServicesApi.crmV1DealsheetRollOffServicesIdDelete(params);
            },
            duplicate: async (params) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesIdDuplicatePost(params);
                return response.data;
            },
            /**
             * Rebuilds haul, dump and overage so the line prices at a target monthly figure.
             * Roll-off has no single unit rate, so a target cannot be written to one column.
             */
            setTargetMonthly: async (params) => {
                const response = await this.rollOffServicesApi.crmV1DealsheetRollOffServicesIdTargetMonthlyPut(params);
                return response.data;
            },
        },
        orderPortaloos: {
            list: async (options) => {
                const response = await this.orderPortaloosApi.crmV1OrderPortaloosGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.orderPortaloosApi.crmV1OrderPortaloosIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.orderPortaloosApi.crmV1OrderPortaloosPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.orderPortaloosApi.crmV1OrderPortaloosIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.orderPortaloosApi.crmV1OrderPortaloosIdDelete(params);
            },
        },
        serviceLocations: {
            list: async (options) => {
                const response = await this.serviceLocationsApi.crmV1ServiceLocationsGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.serviceLocationsApi.crmV1ServiceLocationsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.serviceLocationsApi.crmV1ServiceLocationsPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.serviceLocationsApi.crmV1ServiceLocationsIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.serviceLocationsApi.crmV1ServiceLocationsIdDelete(params);
            },
        },
        sites: {
            /**
             * Merges one section of a site's details, leaving the rest of the document alone.
             * The merge runs in the database, so concurrent edits to different sections — or to
             * different keys within a map-shaped section — do not overwrite one another.
             */
            updateDetailsSection: async (params) => {
                const response = await this.sitesApi.crmV1SitesSiteIdDetailsPatch(params);
                return response.data;
            },
            list: async (options) => {
                const response = await this.sitesApi.crmV1SitesGet(options);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.sitesApi.crmV1SitesIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.sitesApi.crmV1SitesPost(params);
                return response.data;
            },
            update: async (params) => {
                const response = await this.sitesApi.crmV1SitesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.sitesApi.crmV1SitesIdDelete(params);
            },
            search: async (params) => {
                const response = await this.axiosInstance.mainInstance.post('/crm/v1/sites/search', params);
                return response.data;
            },
            /**
             * Drops and recreates the crm-site index, then reindexes every site in the org. There
             * is no way to scope it: the index is deleted first, so a partial reindex would leave
             * the rest of the org missing from search.
             */
            reindex: async () => {
                const response = await this.axiosInstance.mainInstance.post('/crm/v1/sites/reindex');
                return response.data;
            },
            removeLoa: async (siteId) => {
                const response = await this.axiosInstance.mainInstance.post(`/crm/v1/sites/${siteId}/remove-loa`);
                return response.data;
            },
            markLoa: async (siteId, params) => {
                const response = await this.axiosInstance.mainInstance.post(`/crm/v1/sites/${siteId}/mark-loa`, params);
                return response.data;
            },
        },
        issues: {
            list: async (params) => {
                const response = await this.issuesApi.crmV1IssuesGet(params);
                return response.data;
            },
        },
        rfp: {
            query: async (params) => {
                const response = await this.rfpsApi.crmV1DealsheetsDealsheetIDRfpsGet(params);
                return response.data;
            },
            fetch: async (params) => {
                const response = await this.rfpsApi.crmV1RfpsIdGet(params);
                return response.data;
            },
            create: async (params) => {
                const response = await this.rfpsApi.crmV1RfpsPost(params);
                return response.data;
            },
            delete: async (params) => {
                await this.rfpsApi.crmV1RfpsIdDelete(params);
            },
            /**
             * GET /crm/v1/rfps/counts?grain=RFP with multiple vendorID query params, reduced to a
             * completion rate per vendor (responded/total). The rate is computed here so the endpoint
             * itself stays a generic count.
             */
            getCompletionRates: async (vendorIds) => {
                const response = await this.rfpsApi.crmV1RfpsCountsGet({ vendorID: vendorIds, grain: 'RFP' });
                const results = (response.data.results ?? []).map((item) => ({
                    vendorID: item.vendorID ?? '',
                    completionRate: item.total && item.total > 0 ? (item.responded ?? 0) / item.total : 0,
                }));
                return { results };
            },
            /**
             * POST /crm/v1/rfps/:id/send-email
             * Sends (or resends) the vendor-rfp email for an already-existing RFP without creating a duplicate record.
             * Distinct from `create`, which bundles RFP creation + initial email in one shot.
             */
            sendEmail: async (rfpId) => {
                await this.axiosInstance.mainInstance.post(`/crm/v1/rfps/${rfpId}/send-email`);
            },
        },
        rfpSites: {
            list: async (options) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesGet(options);
                return response.data;
            },
            update: async (params) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesIdPut(params);
                return response.data;
            },
            delete: async (params) => {
                await this.rfpSitesApi.crmV1RfpSitesIdDelete(params);
            },
            /**
             * Takes one vendor's LOA lines back out, leaving any other quote at the site alone.
             *
             * Clears the status and drops those lines from the proposal together, because a line
             * left at LOA with no recommendation shows as an LOA that never reaches the customer.
             */
            removeLoa: async (rfpSiteId) => {
                await this.rfpSitesApi.crmV1RfpSitesIdRemoveLoaPost({ id: rfpSiteId });
            },
            /**
             * Puts the site's service lines this quote does not yet carry onto it.
             *
             * A quote is built from the site's lines once, when the RFP is raised, so a line added
             * afterwards reaches no existing quote. Whether a late line belongs in a given vendor's
             * request is a sourcing decision, which is why it is asked for rather than automatic.
             * Returns how many lines were added; running it again adds nothing.
             */
            addMissingLines: async (rfpSiteId) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesIdAddMissingLinesPost({ id: rfpSiteId });
                return response.data.linesAdded ?? 0;
            },
            /**
             * Sets which of a site's quoted service lines are recommended, replacing whatever was
             * recommended there before. The unit is the line, not the vendor: a site can be
             * split, so pass every line that should end up recommended, not just the one toggled.
             * Returns the RFP sites whose summary flag changed.
             */
            recommend: async (siteId, serviceLineIds) => {
                const response = await this.rfpSitesApi.crmV1SitesSiteIdRfpSitesRecommendPost({
                    siteId,
                    body: { serviceLineIds },
                });
                return response.data;
            },
            /**
             * A deal sheet's proposals, one per recommended site. Anchored on the site because an
             * site can be split between vendors and its spend must be counted once.
             */
            listSiteProposals: async (dealsheetID) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesGet({
                    dealsheetID,
                    recommended: CrmV1RfpSitesGetRecommendedEnum.True,
                });
                return response.data;
            },
            /**
             * Deal-sheet-wide proposal rollup. Built server-side from the same per-proposal figures
             * the list returns, and deliberately not paginated: a total over one page is not a total.
             */
            getProposalTotals: async (dealsheetID) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesProposalTotalsGet({ dealsheetID });
                return response.data;
            },
            getServicesWithDetails: async (rfpSiteId) => {
                const response = await this.rfpSitesApi.crmV1RfpSitesRfpSiteIdServicesWithDetailsGet({ rfpSiteId });
                return response.data;
            },
            /** GET /crm/v1/rfp-sites?withVendorDetails=true — returns rfp-sites enriched with site
             *  service-location (city/state/zip), rfp-site services, and calculated proposedPrice.
             *  Used for the SPP RFP list view. */
            listWithVendorDetails: async (options) => {
                const response = await this.axiosInstance.mainInstance.get('/crm/v1/rfp-sites', {
                    params: { ...options, withVendorDetails: true },
                });
                return response.data;
            },
        },
    };
}
export default CRMService;
//# sourceMappingURL=CRM.service.js.map